<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    :style="{ width: '60vw' }"
    :pt="dialogContentPtLoose"
    :maximizable="true"
    :header="$t('views.uploadDocuments.title')"
    @hide="onHide"
  >
    <DocumentsUpload />
    <SelectedDocumentsTable :option-label="'name'" :option-value="'id'" />
  </Dialog>
</template>

<script setup>
import { computed } from "vue"
import { dialogContentPtLoose } from "@/config/dialogPt"
import DocumentsUpload from "@/components/documents/upload/DocumentsUpload.vue"
import SelectedDocumentsTable from "@/components/documents/upload/SelectedDocumentsTable.vue"

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(["update:visible", "hide"])

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value)
})

const onHide = () => {
  emit("hide")
}
</script>

